(function() {

  class MattressFullSpecs {
    constructor(sectionEl) {
      // Save this instance onto the element
      this.sectionEl = sectionEl;
      this.sectionEl.instance = this;

      this.fullDetailsEl = document.querySelector('.MFSFullDetails');
      this.drawerTrigger = document.querySelector('[data-trigger-full-details]');
      this.drawerLabel =
        this.drawerTrigger.querySelector('.MattressFullSpecs__OpenTriggerText');
      this.drawerTriggerSVG = this.drawerTrigger.querySelector('svg');

      this.waitForStylesheetAndLoad();
    }

    init() {
      // Init techSpecs area's max height (used for collapsing).
      this.initSwiper();
      this.fullTechSpecsHeight;
      this.initTechSpecsMaxHeight();

      // Re-init tech specs max height on resize
      window.addEventListener(
        'resize',
        NUtils.debounce(this.initTechSpecsMaxHeight.bind(this), 500)
      );

      // Add collapse functionality on trigger click
      this.drawerTrigger.addEventListener('click', this.toggleCollapse.bind(this));

      // Re-init on load to account for images affecting heights
      window.addEventListener('load', () => {
        this.initTechSpecsMaxHeight();
      });
    }

    /**
     * Updates all swipers and the max height. Good for when content
     * within the section changed.
     */
    updateSwipersAndHeight() {
      this.dimensionsSwiper.update();
      this.constructionSwiper.update();
      this.shippingSwiper.update();
      this.initTechSpecsMaxHeight();
    }

    waitForStylesheetAndLoad() {
      if (document.readyState == 'complete') {
        this.init();
      } else {
        window.addEventListener('load', () => {
          this.init();
        });
      }
    }

    initTechSpecsMaxHeight() {
      this.fullTechSpecsHeight = this.fullDetailsEl.scrollHeight + 'px';

      // Ensure the max height matches the current state of the trigger
      if (this.drawerTrigger.getAttribute('aria-expanded') === 'true') {
        this.fullDetailsEl.style.maxHeight = this.fullTechSpecsHeight;
      } else {
        this.fullDetailsEl.style.maxHeight = 0;
      }
    }

    toggleCollapse() {
      if (this.drawerTrigger.getAttribute('aria-expanded') === 'true') {
        this.fullDetailsEl.style.maxHeight = 0;
        this.drawerTrigger.setAttribute('aria-expanded', 'false');
        this.drawerLabel.innerHTML = 'View Full Product Specs';
        this.drawerTriggerSVG.style.transform = 'rotate(0deg)';
      } else {
        this.fullDetailsEl.style.maxHeight = this.fullTechSpecsHeight;
        this.drawerTrigger.setAttribute('aria-expanded', 'true');
        this.drawerLabel.innerHTML = 'Hide Full Product Specs';
        this.drawerTriggerSVG.style.transform = 'rotate(180deg)';
      }
    }

    initSwiper() {
      this.dimensionsSwiper = new Swiper('.MFSDimensionsArea.swiper-container', {
        slidesPerView: 3,
        roundLengths: true,
        navigation: {
          nextEl: '.MattressFullSpecs__Nav--dimensions .swiper-button-next',
          prevEl: '.MattressFullSpecs__Nav--dimensions .swiper-button-prev',
        },
        pagination: {
          el: '.MattressFullSpecs__Pagination--dimensions',
          type: 'bullets',
          clickable: true,
        },
        breakpoints: {
          767: {
            slidesPerView: 3,
          },
          1025: {
            slidesPerView: 7,
          },
        }
      });

      this.constructionSwiper = new Swiper('.MFSConstructionSwiper.swiper-container', {
        slidesPerView: 1.5,
        roundLengths: true,
        navigation: {
          nextEl: '.MattressFullSpecs__Nav--construction .swiper-button-next',
          prevEl: '.MattressFullSpecs__Nav--construction .swiper-button-prev',
        },
        pagination: {
          el: '.MattressFullSpecs__Pagination--construction',
          type: 'bullets',
          clickable: true,
        },
        breakpoints: {
          767: {
            slidesPerView: 2
          }
        }
      });

      this.shippingSwiper = new Swiper('.MFSShippingSwiper.swiper-container', {
        slidesPerView: 1.5,
        roundLengths: true,
        spaceBetween: 25, 
        navigation: {
          nextEl: '.MattressFullSpecs__Nav--shipping .swiper-button-next',
          prevEl: '.MattressFullSpecs__Nav--shipping .swiper-button-prev',
        },
        pagination: {
          el: '.MattressFullSpecs__Pagination--shipping',
          type: 'bullets',
          clickable: true,
        },
        breakpoints: {
          767: {
            slidesPerView: 2,
            spaceBetween: 60, 
          }
        }
      });

    }
  }

  const sectionEl = document.querySelector('.PDPMSFSSection');
  new MattressFullSpecs(sectionEl);

})();
